module.exports = __webpack_public_path__ + "img/hr-long-handed-inserter-hand-base.746d0a25.png";